<!--
 * @Author: your name
 * @Date: 2020-12-30 22:17:57
 * @LastEditTime: 2021-01-07 08:50:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \beone\src\components\work\org.vue
-->
<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">阳光校务服务大厅</router-link>
        &gt; 办事机构
      </div>
    </div>
    <div class="z_title1" style="margin-top: 10px">办事机构</div>
    <div class="itemsList">
      <div style="display: flex; align-items: center">
        <img
            style="margin-right: 5px"
            src="@/assets/point.jpg"
            width="4"
            height="4"
        />
        <router-link target="_blank" class="STYLE1" to="/work/orgInfo"
        >阳光校务服务机构一览表
        </router-link
        >
      </div>
      <div align="left" class="STYLE1">2017-10-17 15:12:59</div>
    </div>
    <a-pagination style="margin-top:10px" size="small" :total="1"/>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.itemsList {
  margin-top: 20px;
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
